import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  PLATFORM_ID,
  ViewEncapsulation,
  inject,
} from '@angular/core';

@Component({
  selector: 'digital-platform-trustarc-cm',
  styleUrls: ['./trustarc-cm.component.scss'],
  standalone: true,
  imports: [CommonModule],
  templateUrl: './trustarc-cm.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class TrustarcCmComponent implements AfterViewInit {
  @Input() public mode: 'banner' | 'button' = 'banner';

  private platformId = inject(PLATFORM_ID);

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    /** Ensures that the #teconsent element will have the correct event
     * binding in the edge case of the TrustArc script loading
     * BEFORE the element hits the DOM */
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    if ((window as any)?.truste?.eu?.init) {
      (window as any).truste.eu.init();
    }
  }
}
